import { render } from "./PortalView.vue?vue&type=template&id=55ec56c0"
import script from "./PortalView.vue?vue&type=script&lang=js"
export * from "./PortalView.vue?vue&type=script&lang=js"
script.render = render

export default script